module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ga_5.b90bbf5f.jpg";